<nav [class]="'cap-horizontal-navbar navbar navbar-expand ' + styleClass">
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div class="navbar-nav justify-content-center">
            <div *ngIf="!lastItemVisible" class="nav-bar-gradient">
            </div>

            <div *ngIf="!firstItemVisible" class="nav-bar-gradient-left"></div>
            <ng-container *ngFor="let item of filteredItems">
                <cap-nav-item [item]="item" [contentTemplate]="navItemTemplate" [iconTemplate]="navIconTemplate">
                </cap-nav-item>
            </ng-container>
        </div>
    </div>
</nav>
